import api from "../axios_service.js";

export async function getPermissoes(filtros) {
  const response = await api.get(`/permissoes${filtros ? filtros : ""}`);
  return response.data.permissoes;
}

export async function getPermissao(id) {
  const response = await api.get(`/permissoes/${id}`);
  return response.data.permissao;
}

export function putPermissao(id, permissao) {
  let body = {};
  for (let key in permissao) {
    body[key] = permissao[key];
  }
  return api.put(`/permissoes/${id}`, body);
}

export function postPermissao(permissao) {
  let body = {};
  for (let key in permissao) {
    body[key] = permissao[key];
  }
  return api.post("/permissoes/add", body);
}

